import React from "react";
import { PatientScrollArrowTemplate } from "themes/application/facility-order/components";
import { observer } from "mobx-react";

@observer
class PatientScrollArrow extends React.Component {
	render() {
		return <PatientScrollArrowTemplate {...this.props} />;
	}
}

export default PatientScrollArrow;